import workspaceQuery from '../../../graphql/queries/bank/BankReconciliationWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/bank/BankReconciliationQuery.graphql';
import defaultQuery from '../../../graphql/queries/bank/BankReconciliationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/bank/BankReconciliationMutation.graphql';
import temporaryMutationQuery from '../../../graphql/mutations/bank/SaveBankReconciliationTempMutation.graphql';
import fragment from '../../../graphql/fragments/bank/BankReconciliationFragment.graphql';

import { formActionsForPermissions } from '../../../actions/bank/BankReconciliationAction';
import { ALLOW_ADD, ALLOW_DELETE, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const BankReconciliation = {
  type: 'BankReconciliation',
  title: 'Bank Reconciliation',
  formUrl: '/Bank/Reconciliation/Details/',
  formTitle: 'Bank Reconciliation',
  workspaceUrl: '/Bank/Reconciliation/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  screenReference: 'BANK_RECONCILIATION',
  actions: [...formActionsForPermissions],
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['RECONCILED', 'ADJUSTMENT'],
    },
  ],
  operations: ALLOW_VIEW | ALLOW_DELETE | ALLOW_ADD | ALLOW_EDIT,
};

export default BankReconciliation;
